import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Section from 'components/common/Section';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';
import SimulationBox from './SimulationBox';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import CaptionBox from 'components/common/CaptionBox';
import SimulationChart from './SimulationChart';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function SimulationResult(props) {
  const {
    data,
    result,
    agp,
    ...rest
  } = props;

  const {
    avg_bld_sugr: b_avg_bld_sugr = 0,
    gmi: b_gmi = 0,
    cv: b_cv = 0,
    tir: b_tir = 0,
  } = data || {};

  const {
    avg_bld_sugr: a_avg_bld_sugr = 0,
    gmi: a_gmi = 0,
    cv: a_cv = 0,
    tir: a_tir = 0,
  } = result || {};

  return (
    <Section
      {...ex('SimulationResult', rest)}
      {...{
        caption: T('시뮬레이션 결과'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      {result?.uninitialized && (
        <div {...ex('Dim')} >
          <div>
            {T('실행하기 버튼을 누르면 결과를 볼 수 있어요!')}
          </div>
        </div>
      )}
      <HBox {...ex('Boxes')}>
        <SimulationBox
          {...{
            caption: T('평균혈당'),
            unit: 'mg/dL',
            variation: {
              value: +(a_avg_bld_sugr - b_avg_bld_sugr).toFixed(1),
              type: CHECK_COLORS('N', a_avg_bld_sugr - b_avg_bld_sugr),
            },
            before: {
              value: b_avg_bld_sugr,
              type: CHECK_COLORS('B', b_avg_bld_sugr),
            },
            after: {
              value: a_avg_bld_sugr,
              type: CHECK_COLORS('B', a_avg_bld_sugr),
            },
          }}
        />
        <SimulationBox
          {...{
            caption: T('GMI'),
            unit: '%',
            variation: {
              value: +(a_gmi - b_gmi).toFixed(1),
              type: CHECK_COLORS('N', a_gmi - b_gmi),
            },
            before: {
              value: b_gmi,
              type: CHECK_COLORS('GMI', b_gmi),
            },
            after: {
              value: a_gmi,
              type: CHECK_COLORS('GMI', a_gmi),
            },
          }}
        />
        <SimulationBox
          {...{
            caption: T('CV'),
            unit: '%',
            variation: {
              value: +(a_cv - b_cv).toFixed(1),
              type: CHECK_COLORS('N', a_cv - b_cv),
            },
            before: {
              value: b_cv,
              type: CHECK_COLORS('CV', b_cv),
            },
            after: {
              value: a_cv,
              type: CHECK_COLORS('CV', a_cv),
            },
          }}
        />
        <SimulationBox
          {...{
            caption: T('TIR'),
            unit: '%',
            variation: {
              value: +(a_tir - b_tir).toFixed(1),
              type: CHECK_COLORS('P', a_tir - b_tir),
            },
            before: {
              value: b_tir,
              type: CHECK_COLORS('TIR', b_tir),
            },
            after: {
              value: a_tir,
              type: CHECK_COLORS('TIR', a_tir),
            },
          }}
        />
      </HBox>
      <HBox {...ex('Charts')}>
        <VBox full>
          <HBox>
            {T('시뮬레이션 전 AGP')}
          </HBox>
          <SimulationChart />
        </VBox>
        <VBox full>
          <HBox>
            {T('시뮬레이션 후 AGP')}
          </HBox>
          <SimulationChart {...{ agp }} />
        </VBox>
      </HBox>
    </Section>
  );
}
